require('./hiringProductInformationCharacteristics.scss');
require('./hiringProductInformationCharacteristics.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

class HiringProductInformationCharacteristics extends React.Component {

    render() {
        const { immCharacteristics } = this.props;
        return (
            <div className="hiring-product-information-characteristics">
                <HTMLSafeInjector
                    message={immCharacteristics.getIn(['field_characteristics', 'value'])}
                />
            </div>
        );
    }
}

HiringProductInformationCharacteristics.propTypes = {
    immCharacteristics: PropTypes.object,
};

module.exports = HiringProductInformationCharacteristics;